<template>
  <div :class="classes.content">
    <div :class="[classes.columnGroup]">
      <div :class="classes.infoGroup">
        <LinkWrapper
          :href="offferLink"
          target="_blank"
          :class="[classes.offerLink, 'offer-link']"
          @click="() => offerHandleClick()"
        >
          <OfferHeader :class="[classes.offerHeader]">
            {{ offerHeader }}
          </OfferHeader>

          <OfferFittedText
            :class="classes.offerText"
            :offerText="offerText"
            alignment="flex-start"
            justifyContent="flex-start"
          />
        </LinkWrapper>
      </div>

      <LinkWrapper
        :href="offferLink"
        target="_blank"
        :class="classes.offerButton"
        @click="() => offerHandleClick()"
      >
        <Button />
      </LinkWrapper>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import Button from "./Button.vue";
import OfferHeader from "../../branded/OfferHeader.vue";

import LinkWrapper from "../../LinkWrapper.vue";
import OfferFittedText from "../../OfferFittedText.vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { injectCardNumber, useAnalytics } from "../../../hooks/useAnalytics";
import { injectOffer } from "@fresh8/ad-data-composition/src/offer";
import { useCenterMobileLeaderboard } from "../../../hooks/useLayout";

const useStyles = createUseStyles({
  //@ts-ignore
  content: props => ({
    flex: 1,
    display: "flex",
    flexDirection: "row",
    height: "inherit",

    ...props.mlbCenterStyles
  }),
  textWrapper: {
    flex: "1 1 0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  columnGroup: {
    display: "flex",
    boxSizing: "border-box",
    height: "100%",
    width: "100%",
    gap: "6px",
    padding: "2px 4px"
  },
  infoGroup: {
    display: "flex",
    width: "100%",
    flexDirection: "column"
  },
  offerHeader: {
    display: "inline-flex",
    fontSize: "10px",
    textAlign: "left",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    boxSizing: "border-box",
    lineHeight: 1
  },

  offerText: {
    width: "100%",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflow: "hidden",
    position: "relative",
    maxHeight: "22px",

    "& span": {
      justifyContent: "center !important",
      width: "100%",
      flex: 1
    }
  },

  offerButton: {
    textAlign: "center",
    maxWidth: "64px",

    lineHeight: "1.2",

    "& span": {
      fontSize: "10px"
    }
  },

  resize: {
    pointerEvents: "none",
    zIndex: -99
  },
  offerLink: {
    display: "flex",
    flexDirection: "column",
    height: "100%"
  }
});

export default defineComponent({
  name: "MobileLeaderboardOffer",
  components: { Button, OfferFittedText, OfferHeader, LinkWrapper },
  setup(props) {
    const offerContext = injectOffer();

    const offerText = computed(
      () => offerContext?.offer.value && offerContext?.offer.value.body
    );

    const mlbCenterStyles = useCenterMobileLeaderboard();
    const computedStyles = computed(() => ({
      mlbCenterStyles: mlbCenterStyles.value
    }));
    const classes = useStyles(computedStyles);

    const cardNumber = injectCardNumber();

    return {
      classes,
      offerText,
      offerHeader: computed(
        () => offerContext?.offer.value && offerContext?.offer.value.header
      ),

      offferLink: computed(
        () =>
          (offerContext?.offer.value && offerContext?.offer.value?.link) || "#"
      ),
      offerHandleClick: useAnalytics({ cardNumber: cardNumber }, "Offer Card")
        .handleClick
    };
  }
});
</script>
